'use client';

import { c as _c } from "react/compiler-runtime";
import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '../../utils/cn';
const toggleVariants = cva("inline-flex items-center cursor-pointer disabled:cursor-not-allowed justify-center gap-2 rounded-md text-sm font-medium hover:bg-muted hover:text-muted-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap", {
  variants: {
    variant: {
      default: 'bg-transparent',
      outline: 'border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground'
    },
    size: {
      default: 'h-9 px-2 min-w-9',
      sm: 'h-8 px-1.5 min-w-8',
      lg: 'h-10 px-2.5 min-w-10'
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'default'
  }
});
function Toggle(t0) {
  const $ = _c(12);
  let className;
  let props;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
    $[4] = variant;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
    variant = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== size || $[7] !== variant) {
    t1 = cn(toggleVariants({
      variant,
      size,
      className
    }));
    $[5] = className;
    $[6] = size;
    $[7] = variant;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== props || $[10] !== t1) {
    t2 = <TogglePrimitive.Root data-slot="toggle" className={t1} {...props} />;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
export { Toggle, toggleVariants };